import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { MarketplaceCardSmall } from 'marketplace-embed/js/components/MarketplaceCardSmall';
import { UsageScreenProvider, useTrackMarketplaceEvent, useUsageTracker } from 'marketplace-ui-tracking';
import { SearchResultViewTracker, getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useCallback, useMemo } from 'react';
import { generatePath, useHistory } from 'quartz-routing/react-router';
import { Paths } from '../../constants/paths';
import { Subscreens } from '../../constants/usage';
import { CollectionCard } from './CollectionCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CollectionSection(props) {
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    subscreen: Subscreens.COLLECTION_SECTION,
    children: /*#__PURE__*/_jsx(CollectionSectionContent, Object.assign({}, props))
  });
}
function CollectionSectionContent({
  buttonText,
  cards,
  collectionId,
  collectionSlug,
  description,
  href,
  productType,
  queryType,
  sectionCount,
  sectionIndex,
  title
}) {
  const {
    isMobile
  } = useResponsiveProps({
    isMobile: {
      xs: true,
      lg: false
    }
  });
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const collectionIdNumber = typeof collectionId === 'number' ? collectionId : undefined;
  const searchResultEventProps = useMemo(() => ({
    listingId: collectionIdNumber,
    resultCount: sectionCount,
    resultIndex: sectionIndex,
    resultType: 'COLLECTION',
    slug: collectionSlug,
    type: productType
  }), [collectionIdNumber, collectionSlug, productType, sectionCount, sectionIndex]);
  const trackButtonClicked = useCallback(() => {
    trackMarketplaceEvent(getSearchResultClickedEvent(searchResultEventProps));
  }, [trackMarketplaceEvent, searchResultEventProps]);
  return /*#__PURE__*/_jsx(CardWrapper, {
    "data-test-id": "collection-section",
    marginBlockEnd: "1000",
    children: /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsxs(Grid, {
        rowGap: "800",
        children: [/*#__PURE__*/_jsx(GridItem, {
          size: {
            xs: 12,
            lg: 6
          },
          children: /*#__PURE__*/_jsx(SearchResultViewTracker, Object.assign({}, searchResultEventProps, {
            children: /*#__PURE__*/_jsx(CollectionCard, {
              buttonText: buttonText,
              description: description,
              href: href,
              name: title,
              onClick: trackButtonClicked,
              removeCardWrapper: true,
              slug: collectionSlug,
              previewItems: isMobile ? cards.map(card => ({
                listingId: card.listingId,
                iconUrl: card.iconUrl,
                name: card.listingName
              })) : undefined,
              totalItemCount: isMobile ? cards.length : 0
            })
          }))
        }), !isMobile && /*#__PURE__*/_jsx(GridItem, {
          size: {
            xs: 12,
            lg: 6
          },
          children: /*#__PURE__*/_jsx(Grid, {
            rowGap: "400",
            children: cards.map((card, index) => /*#__PURE__*/_jsx(GridItem, {
              size: {
                xs: 12,
                md: 4,
                lg: 6
              },
              children: /*#__PURE__*/_jsx(CollectionListingCard, {
                card: card,
                collectionId: collectionIdNumber,
                collectionSlug: collectionSlug,
                queryType: queryType,
                resultCount: cards.length,
                resultIndex: index
              })
            }, card.listingId))
          })
        })]
      })
    })
  });
}
function CollectionListingCard({
  card,
  collectionId,
  collectionSlug,
  queryType,
  resultCount,
  resultIndex
}) {
  const tracker = useUsageTracker();
  const history = useHistory();
  if (!card.slug) return null;
  const listingHref = generatePath(Paths.LISTING_DETAILS, {
    listingSlug: card.slug
  });
  return /*#__PURE__*/_jsx(MarketplaceCardSmall, {
    listing: card,
    onClick: () => history.push(listingHref),
    tracker: tracker,
    trackingProps: {
      collectionId,
      collectionSlug,
      queryType,
      resultCount,
      resultIndex
    },
    transparent: true
  });
}